/**
 * `/raporty/nowa`'s search: `?klient=<id>` when the editor was opened FOR a client — the client
 * card's „Przypisz ankietę" → „Utwórz nową ankietę" (8 October 2026). The first save then assigns
 * the new check-in to that client and returns to their Ankiety tab instead of to the list.
 *
 * Polish, as every address in this app is (`model/reportTabs`). Anything but a positive integer is
 * DROPPED rather than kept: a malformed id would otherwise post an assignment to `/customer/0`'s
 * equivalent and fail after the form had already been created.
 *
 * No React, no DOM, no query hook, no i18next.
 */

export interface NewSurveySearch {
  readonly klient?: number;
}

export function validateNewSurveySearch(raw: Record<string, unknown>): NewSurveySearch {
  const { klient } = raw;
  // A number or its text, and nothing else: `Number(true)` is 1 and `Number([12])` is 12.
  const value =
    typeof klient === 'number'
      ? klient
      : typeof klient === 'string' && klient.trim() !== ''
        ? Number(klient)
        : Number.NaN;
  // OMITTED rather than `undefined`, so the router does not serialise a bare `?klient=`.
  return Number.isInteger(value) && value > 0 ? { klient: value } : {};
}
